import {
    FETCH_DISTRICT_LIST, FETCH_FAQ_CATEGORY, FETCH_FAQ, FETCH_FLICKR_IMAGES, FETCH_FLICKR_DETAIL_IMAGES,
    FETCH_SETTINGS, SHOW_PRELOADER, FETCH_PARTNER_STORIES, FETCH_DASHBOARD_DATA
} from "../constants/actionType";
import {
    DISTRICT_LIST_API_URL, FAQ_CATEGORY_LIST_API_URL, FAQ_API_URL, FLICKER_IMAGES_API_URL,
    FLICKER_DETAIL_IMAGES_API_URL, SETTINGS_API_URL, PARTNERS_STORIES_LIST_API_URL, DASHBOARD_LIST_API_URL
} from "../constants/urls";

function fetchDistrictList(url) {
    url = url && url.length > 0 ? url : DISTRICT_LIST_API_URL;
    if (url) {
        return {
            type: FETCH_DISTRICT_LIST,
            request: {
                url: url
            }
        };
    }
}

function fetchDashboardList(url){
    url = url && url.length > 0 ? url : DASHBOARD_LIST_API_URL;
    if (url) {
        return {
            type: FETCH_DASHBOARD_DATA,
            request: {
                url
            }
        };
    }
}

function fetchFAQCategories(url) {
    url = url && url.length > 0 ? url : FAQ_CATEGORY_LIST_API_URL;
    if (url) {
        return {
            type: FETCH_FAQ_CATEGORY,
            request: {
                url: url
            }
        };
    }
}

function fetchFAQ(url) {
    url = url && url.length > 0 ? url : FAQ_API_URL;
    if (url) {
        return {
            type: FETCH_FAQ,
            request: {
                url: url
            }
        };
    }
}

function fetchFlickrImages(url, perPage = 20) {
    url = url && url.length > 0 ? url : FLICKER_IMAGES_API_URL;
    if (url) {
        url = `${url}&per_page=${perPage}&page=1`;
        return {
            type: FETCH_FLICKR_IMAGES,
            request: {
                url: url
            }
        };
    }
}

function fetchFlickrDetailImages(url, perPage = 20) {
    url = url && url.length > 0 ? url : FLICKER_DETAIL_IMAGES_API_URL;
    if (url) {
        url = `${url}&per_page=${perPage}`;
        return {
            type: FETCH_FLICKR_DETAIL_IMAGES,
            request: {
                url: url
            }
        };
    }
}

function fetchSettings(){
    return {
        type: FETCH_SETTINGS,
        request: {
            url: SETTINGS_API_URL
        }
    };
}

function showPreloaderAction(payload){
    return {
        type: SHOW_PRELOADER,
        payload
    }
}

function fetchPartnerStoriesList(url){
    url = url && url.length > 0 ? url : PARTNERS_STORIES_LIST_API_URL;
    if (url) {
        return {
            type: FETCH_PARTNER_STORIES,
            request: {
                url: url
            }
        };
    }
}

export {
    fetchDistrictList,
    fetchDashboardList,
    fetchFAQCategories,
    fetchFAQ,
    fetchFlickrImages,
    fetchFlickrDetailImages,
    fetchSettings,
    showPreloaderAction,
    fetchPartnerStoriesList
};